const normalize = (value) => String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();

export function uniqueStudyingExams(exams = []) {
  const unique = new Map();

  exams.forEach((exam, index) => {
    if (!exam) return;
    const name = normalize(exam?.exam_name);
    const state = normalize(exam?.state_name);
    const key = name ? `${name}::${state}` : `id:${exam?.md_exams_id || index}`;
    const previous = unique.get(key);

    if (!previous || (Number(exam?.default_exam) === 1 && Number(previous.default_exam) !== 1)) {
      unique.set(key, exam);
    }
  });

  return [...unique.values()];
}
